import { usePageUrlFilter } from '@va/dashboard/shared/filters';
import { useHistory } from 'react-router';

export const useLatestVisitorsInitialFilters = () => {
  const history = useHistory<{ pageUrl?: string } | undefined>();
  const pageUrlFilter = usePageUrlFilter();

  if (history.location.state?.pageUrl) {
    pageUrlFilter.values = [history.location.state.pageUrl];

    return [pageUrlFilter];
  }
};
